/**
 * Collection quick links (sections/collection-quick-links.liquid).
 *
 * - The arrow shows only while the row has more buttons to scroll to, and
 *   scrolls it on by most of its width.
 * - GA4, two events:
 *     collection_links_view   the row was at least half visible for one second
 *                             (once per page view)
 *     collection_link_click   a button was clicked
 *   Interaction rate = sessions with collection_link_click / sessions with
 *   collection_links_view. The most clicked buttons: collection_link_click by
 *   link_collection, which holds the button's destination path (a collection
 *   or any other link) without the language prefix, e.g. /collections/new-in,
 *   so one button counts as one row in every language. Same viewability rule
 *   as assets/upsell-analytics.js.
 */
(function () {
  'use strict';

  var VIEW_THRESHOLD = 0.5;
  var VIEW_DWELL_MS = 1000;
  var SCROLL_MS = 350;

  function send(name, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', name, params);
  }

  // Shopify localises store links (/es/collections/...); drop that prefix
  function withoutLocale(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/' && path.indexOf(root) === 0) return '/' + path.slice(root.length);
    return path;
  }

  function watchView(root, params) {
    if (!('IntersectionObserver' in window)) {
      send('collection_links_view', params);
      return;
    }
    var timer = null;
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          timer = setTimeout(function () {
            observer.disconnect();
            send('collection_links_view', params);
          }, VIEW_DWELL_MS);
        } else {
          clearTimeout(timer);
        }
      },
      { threshold: VIEW_THRESHOLD }
    );
    observer.observe(root);
  }

  function init(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = 'true';

    var list = root.querySelector('[data-cql-list]');
    var more = root.querySelector('[data-cql-more]');
    var links = root.querySelectorAll('[data-cql-link]');
    var base = {
      from_collection: root.dataset.fromCollection || undefined,
      country: root.dataset.country || undefined
    };

    var updateMore = function () {
      more.hidden = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    };
    // Animated by setting scrollLeft each frame, not scrollBy({ behavior:
    // 'smooth' }): after a native smooth scroll iOS Safari keeps hit-testing
    // the row at its old offset, so the buttons just scrolled into view
    // (Meller Lab) could not be tapped.
    more.addEventListener('click', function () {
      var from = list.scrollLeft;
      var distance = Math.min(list.clientWidth * 0.7, list.scrollWidth - list.clientWidth - from);
      var start = null;
      var step = function (now) {
        if (start === null) start = now;
        var t = Math.min((now - start) / SCROLL_MS, 1);
        list.scrollLeft = from + distance * (1 - Math.pow(1 - t, 3)); // ease-out
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
    list.addEventListener('scroll', updateMore, { passive: true });
    window.addEventListener('resize', updateMore);
    updateMore();

    // Keep the active button in view on a narrow screen
    var active = list.querySelector('.is-active');
    if (active && active.offsetLeft + active.offsetWidth > list.clientWidth) {
      list.scrollLeft = active.offsetLeft - 20;
      updateMore();
    }

    watchView(root, {
      from_collection: base.from_collection,
      country: base.country,
      links_count: links.length
    });

    // The click leaves the page, so the hit goes out as a beacon
    list.addEventListener('click', function (event) {
      var link = event.target.closest('[data-cql-link]');
      if (!link) return;
      send('collection_link_click', {
        link_label: link.textContent.trim(),
        link_collection: withoutLocale(link.dataset.target),
        link_position: Number(link.dataset.position),
        from_collection: base.from_collection,
        country: base.country,
        transport_type: 'beacon'
      });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-collection-quick-links]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
